import React from 'react';
import DiglettSprite from './DiglettSprite';
import { tunnelTrackImg } from '../../../constants/items';

const RaceTrack = ({ 
  raceData = { racers: [] }, 
  trackWidth = 100, 
  trackHeight = 500 
}) => {

  return (
    <div 
      className="race-track" 
      style={{ 
        position: 'relative',
        width: trackWidth * 4, // Scale up for visibility (400px wide)
        height: trackHeight, // Keep original height (500px)
        backgroundImage: `url(${tunnelTrackImg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%', // Use full image dimensions
        backgroundPosition: 'center',
        border: '3px solid #8B4513',
        borderRadius: '8px',
        overflow: 'hidden'
      }}
    >
      {/* Single track - no lane dividers needed */}
      {/* Progress markers every 25% vertically */}
      {[25, 50, 75].map(marker => (
        <div 
          key={marker} 
          className="progress-marker" 
          style={{ 
            position: 'absolute',
            top: `${100 - marker}%`,
            left: '0',
            width: '100%',
            height: '2px',
            backgroundColor: 'rgba(255,255,255,0.2)',
            borderRadius: '1px'
          }} 
        />
      ))}

      {/* Finish line at top */}
      <div 
        className="finish-line" 
        style={{ 
          position: 'absolute',
          top: '20px',
          left: 0,
          width: '100%',
          height: '4px',
          background: 'repeating-linear-gradient(90deg, #fff 0px, #fff 10px, #000 10px, #000 20px)',
          zIndex: 15
        }} 
      />

      {/* Finish line flag */}
      <div style={{
        position: 'absolute',
        top: '5px',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '20px',
        zIndex: 16
      }}>
        🏁
      </div>

      {/* Diglett sprites */}
      {raceData.racers && raceData.racers.map((racer, index) => (
        <DiglettSprite
          key={racer.id || index}
          position={racer.position || 0}
          lane={index}
          isPlayer={racer.isPlayer || index === 0}
          animationState={racer.animationState || 'underground'}
          trackWidth={trackWidth}
          trackHeight={trackHeight}
        />
      ))}

      {/* Race status overlay */}
      <div style={{
        position: 'absolute',
        top: '10px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: '#fff',
        padding: '8px 16px',
        borderRadius: '20px',
        fontSize: '14px',
        fontWeight: 'bold',
        zIndex: 20
      }}>
        {raceData.status || 'Ready to Race!'}
      </div>
    </div>
  );
};

export default RaceTrack;